import {useEffect, useState, useContext} from "react";
import {FaHeart} from "react-icons/fa";
import {AppContext} from "@/pages/_app";
import { Spinner } from "react-bootstrap";
import { callBackendApi } from "@/utils/common";
import { OverlayTrigger } from "react-bootstrap";


export const BtnLikePost = (props)=> {
    const { loggedInUser, refreshLoggedInUser, popoverLoginAlert } = useContext(AppContext);
    const {post, iconStyle, textClass, className} = props;
    const postId = post._id;
    const [liked, setLiked] = useState(false);
    const [countLikes, setCountLikes] = useState(0);
    const [loading, setLoading] = useState(true);
    
    console.log(props.post.isLiked);
    const handleLike = async ()=> {
        setLoading(true);
        // get post like status
        await callBackendApi({
            method : "post",
            url : "/community/likes/post/" + postId
        })
            .then((response) => {
                if (response.data.success == true) {
                    setLiked(true);
                    setCountLikes(countLikes + 1);
                } else {
                    setLiked(false);
                }
            })
            .catch((error) => {
                console.log({error});
            })
            setLoading(false);
            window.analytics.track(`post_liked`, {
                post : post ,
                user : loggedInUser ? loggedInUser : null
          
              });
    }

    const handleUnLike = async ()=> {
        setLoading(true);
        // get post like status
        await callBackendApi({
            method : "delete",
            url : "/community/likes/post/" + postId
        })
            .then((response) => {

                if (response.data.success == true) {
                    setLiked(false);
                    setCountLikes(countLikes - 1);
                } else {
                    setLiked(true);
                }
            })
            .catch((error) => {
                console.log({error});
            })
            setLoading(false);
            window.analytics.track(`post_unliked`, {
                post : post ,
                user : loggedInUser ? loggedInUser : null
              })
    }

    const handleClick = ()=> {
        if (liked) {handleUnLike();} else {handleLike();}
    }

    useEffect(async ()=>{
        setLiked(post.isLiked);
        setCountLikes(post.countLikes);
        setLoading(false);
    }, [post])
    return (
        <OverlayTrigger trigger={!loggedInUser && "click"} placement="top" rootClose overlay={popoverLoginAlert} >
            <button  disabled={loading} onClick={()=> {loggedInUser && handleClick();}} 
            {...props}
            className={ (liked && " active ") + className}>
                <FaHeart style={iconStyle} className={" mds-btn-icon " + (liked && " active ")} />
                {loading ? 
                <Spinner animation="border" size="sm" />
                :
                <span className={textClass || "mds-fs-4 mds-fw-md"}>{countLikes}</span> 
            }
            </button>
            </OverlayTrigger>
            
    )
}
